// In-App "Frequency" authoring state ↔ the stored `frequency` doc. P2-2 (DA-BUG-1032): "Once per
// session" is sent as its own per-session cap `max_per_session` ({enabled,value:1}), which RRS maps to
// the device's `maxPerSession` (reset when the In-App session clock starts a new session). It is no
// longer folded into the lifetime cap (`max_lifetime` → `maxDisplays`). `once_per_session` is still
// sent for older readers.
export interface FrequencySettings {
  oncePerSession: boolean;
  maxPerDayEnabled: boolean;
  maxPerDay: number;
  maxLifetimeEnabled: boolean;
  maxLifetime: number;
  cooldownEnabled: boolean;
  cooldownValue: number;
  cooldownUnit: "hours" | "days";
  stopAfterConversion: boolean;
}

export function frequencyFromApi(f: any): FrequencySettings {
  const fr = f && typeof f === "object" ? f : {};
  return {
    oncePerSession: fr.once_per_session ?? true,
    maxPerDayEnabled: fr.max_per_day?.enabled ?? false,
    maxPerDay: fr.max_per_day?.value ?? 1,
    maxLifetimeEnabled: fr.max_lifetime?.enabled ?? false,
    maxLifetime: fr.max_lifetime?.value ?? 3,
    cooldownEnabled: fr.cooldown_after_dismissal?.enabled ?? false,
    cooldownValue: fr.cooldown_after_dismissal?.value ?? 24,
    cooldownUnit: fr.cooldown_after_dismissal?.unit === "days" ? "days" : "hours",
    stopAfterConversion: fr.stop_after_conversion ?? true,
  };
}

export function frequencyToApi(s: FrequencySettings) {
  return {
    once_per_session: s.oncePerSession,
    max_per_session: { enabled: s.oncePerSession, value: 1 },
    max_per_day: { enabled: s.maxPerDayEnabled, value: s.maxPerDay },
    max_lifetime: { enabled: s.maxLifetimeEnabled, value: s.maxLifetime },
    cooldown_after_dismissal: { enabled: s.cooldownEnabled, value: s.cooldownValue, unit: s.cooldownUnit },
    stop_after_conversion: s.stopAfterConversion,
  };
}
